// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"362573b4","455":"76c0c96b","977":"138375e0"}[chunkId] + ".chunk.js";
};